import { render, staticRenderFns } from "./ExportAsButton.vue?vue&type=template&id=2e07c52b&scoped=true&"
import script from "./ExportAsButton.vue?vue&type=script&lang=js&"
export * from "./ExportAsButton.vue?vue&type=script&lang=js&"
import style0 from "./ExportAsButton.vue?vue&type=style&index=0&id=2e07c52b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e07c52b",
  null
  
)

export default component.exports